import React from 'react'

export default function TopDiv() {
  return (
    <div className='bg-blue-500 text-neutral-50 font-semibold text-xl py-1.5'>
        Lorem Ipsum is simply dummy text of the printing
    </div>
  )
}
